import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const initialState = {
  agents: [],
  status: "idle",
  error: null,
};

const apiUrl = process.env.REACT_APP_API_URL;

// Update Agent
export const updateAgent = createAsyncThunk(
  "agents/updateAgent",
  async ({ id, product, agent, parentId, agent_price }) => {
    const url = `${apiUrl}/Agent/ProductAgents/${id}/`; // API endpoint

    const response = await axios.put(
      url,
      { id, product, agent, parent_id: parentId, agent_price },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      }
    );
    return response.data;
  }
);

// Delete Agent
export const deleteAgent = createAsyncThunk(
  "agents/deleteAgent",
  async (id) => {
    await axios.delete(`${apiUrl}/Agent/ProductAgents/${id}/`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
      },
    });
    return id;
  }
);

export const createAgent = createAsyncThunk(
  "agents/createAgent",
  async ({ productId, agentsID, parentID }) => {
    const url = `${apiUrl}/Agent/ProductAgents/${agentsID}/`;

    const response = await axios.post(
      url,
      { product: productId, agent: agentsID, parent_id: parentID },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      }
    );
    return response.data;
  }
);

// Search Agent
export const searchAgent = createAsyncThunk(
  "agents/searchAgent",
  async ({ agent_id, query = "" }) => {
    const url = query
      ? `${apiUrl}/Agent/${agent_id}/Search/?query=${query}`
      : `${apiUrl}/Agent/${agent_id}/Search/`;

    const response = await axios.get(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
      },
    });
    return response.data;
  }
);

const agentsSlice = createSlice({
  name: "agents",
  initialState,
  reducers: {
    setAgents(state, action) {
      state.agents = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateAgent.pending, (state) => {
        state.status = "loading";
      })
      .addCase(updateAgent.fulfilled, (state, action) => {
        const index = state.agents.findIndex(
          (agent) => agent.id === action.payload.id
        );
        if (index !== -1) {
          state.agents[index] = action.payload;
        }
        state.status = "succeeded";
      })
      .addCase(updateAgent.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(deleteAgent.pending, (state) => {
        state.status = "loading";
      })
      .addCase(deleteAgent.fulfilled, (state, action) => {
        state.agents = state.agents.filter(
          (agent) => agent.id !== action.payload
        );
        state.status = "succeeded";
      })
      .addCase(deleteAgent.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(createAgent.pending, (state) => {
        state.status = "loading";
      })
      .addCase(createAgent.fulfilled, (state, action) => {
        state.agents.push(action.payload); // Add new agent to the state
        state.status = "succeeded";
      })
      .addCase(createAgent.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(searchAgent.pending, (state) => {
        state.status = "loading";
      })
      .addCase(searchAgent.fulfilled, (state, action) => {
        state.agents = action.payload; // Update state with the search result
        state.status = "succeeded";
      })
      .addCase(searchAgent.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export const { setAgents } = agentsSlice.actions;

export default agentsSlice.reducer;
